module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.backgroundCard) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('Avatar', {
    attrs: {
      "src": _vm.newImageBase64,
      "showPreview": _vm.showPreview,
      "isSquare": _vm.requirementsBelowImage,
      "placeholder": _vm.placeholder,
      "showDefaultPlaceholderImg": _vm.showDefaultPlaceholderImg
    },
    on: {
      "click": _vm.uploadPhoto
    }
  }), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "avatar-spacer"
  }) : _vm._e(), _vm._v(" "), (_vm.showRequirements) ? _c('Requirements', {
    attrs: {
      "requirements": _vm.requirementsList,
      "isSizeOk": _vm.localIsSizeOk,
      "isFormatOk": _vm.localIsFormatOk,
      "horizontal": _vm.requirementsHorizontal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showButton) ? _c('UploadButton', {
    attrs: {
      "hasImage": !!_vm.newImageBase64,
      "buttonType": _vm.buttonType
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.uploadPhoto.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input', {
    ref: "inputAvatarUpload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileInputChange
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.backgroundCard) ? _c('div', [_c('div', {
    staticClass: "d-flex add-image bg-medium pointer p-3 radius-top-left-normal radius-top-right-normal",
    style: ('background-image : url(' + _vm.newImageBase64 + ')'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.uploadPhoto.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-start w-100"
  }, [(_vm.showButton) ? _c('button', {
    staticClass: "btn secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.uploadPhoto.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.newImageBase64 ? 'Edit Picture' : 'Select Picture') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "inputAvatarUpload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileInputChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "requirements-wrapper card-requirements mt-1 mb-1 d-flex justify-content-center"
  }, [(_vm.showRequirements) ? _c('Requirements', {
    attrs: {
      "requirements": _vm.requirementsList,
      "isSizeOk": _vm.localIsSizeOk,
      "isFormatOk": _vm.localIsFormatOk,
      "horizontal": _vm.requirementsHorizontal
    }
  }) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3d039f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AvatarUploader.vue
// module id = 1473
// module chunks = 0